import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Plus } from '@phosphor-icons/react';

export const NewAgencyDialog = ({
  newAgencyDialog, setNewAgencyDialog,
  newAgencyData, setNewAgencyData,
  handleCreateNewAgency,
}) => (
  <Dialog open={newAgencyDialog} onOpenChange={setNewAgencyDialog}>
    <DialogContent className="max-w-md">
      <DialogHeader><DialogTitle>New Agency Add Karo</DialogTitle></DialogHeader>
      <div className="space-y-4">
        <div>
          <Label className="form-label">Agency Name *</Label>
          <Input value={newAgencyData.name} onChange={(e) => setNewAgencyData({ ...newAgencyData, name: e.target.value })} className="uppercase" data-testid="new-agency-name-input" />
        </div>
        <div>
          <Label className="form-label">Company Type</Label>
          <select value={newAgencyData.company_type} onChange={(e) => setNewAgencyData({ ...newAgencyData, company_type: e.target.value })}
            className="w-full border border-gray-200 rounded-md h-10 px-3 text-sm" data-testid="new-agency-type-select">
            <option value="">Select Type</option>
            <option value="INDANE">Indane</option>
            <option value="BHARAT">Bharat Gas</option>
            <option value="HP">HPCL / HP Gas</option>
            <option value="OTHER">Other</option>
          </select>
        </div>
        <div>
          <Label className="form-label">Default Rate</Label>
          <Input type="number" step="0.01" value={newAgencyData.rate} onChange={(e) => setNewAgencyData({ ...newAgencyData, rate: e.target.value })} placeholder="0.00" data-testid="new-agency-rate-input" />
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => setNewAgencyDialog(false)}>Cancel</Button>
        <Button className="btn-primary" onClick={handleCreateNewAgency} data-testid="new-agency-save-btn">
          <Plus size={16} className="mr-1" /> Create Agency
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
